function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m379.5 0h-231c-27.296 0-49.5 22.204-49.5 49.5v429c0 27.296 22.204 49.5 49.5 49.5h231c27.296 0 49.5-22.204 49.5-49.5v-429c0-27.296-22.204-49.5-49.5-49.5zm-231 33h231c9.104 0 16.5 7.396 16.5 16.5v346.5h-264v-346.5c0-9.104 7.396-16.5 16.5-16.5zm231 462h-231c-9.104 0-16.5-7.396-16.5-16.5v-49.5h264v49.5c0 9.104-7.396 16.5-16.5 16.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m275.667 450.333c6.444 6.444 6.444 16.891 0 23.335s-16.891 6.444-23.335 0-6.444-16.891 0-23.335 16.891-6.444 23.335 0"
});

var SvgCommunicationsV2 = function SvgCommunicationsV2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 528 528",
    height: 512,
    viewBox: "0 0 528 528",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommunicationsV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/communications_v2.7bc27c63.svg";
export { ForwardRef as ReactComponent };